<template>
  <v-card>
    <form-header
      :fullscreen="false"
      :title='$lang("reservations.amount_details.title")'
    ></form-header>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <v-simple-table v-if="form.summary">
              <template v-slot:default>
                <thead>
                <tr>
                  <th>{{ $lang('reservations.amount_details.fields.date') }}</th>
                  <th>{{ $lang('reservations.amount_details.fields.amount') }}</th>
                  <th>{{ $lang('reservations.fields.discount') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(amountDetail, i) in form.amount_details" :key="i">
                  <td>{{ $toDateFormat(amountDetail.date) }}</td>
                  <td>
                    <v-text-field
                      readonly
                      type="number"
                      v-model="amountDetail.amount"
                      dense
                      :suffix="form.summary.currency"
                      :error="!!validation[`amount_details.${i}.amount`]"
                      :error-messages="!!validation[`amount_details.${i}.amount`] ? validation[`amount_details.${i}.amount`] : []"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      readonly
                      type="number"
                      v-model="amountDetail.discount"
                      dense
                      :suffix="form.summary.currency"
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <th>{{ $lang('reservations.labels.total') }}</th>
                  <th>
                    <v-text-field
                      v-model="total"
                      disabled
                      dense
                      hide-details
                      :suffix="form.summary.currency"
                    ></v-text-field>
                  </th>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="close()">{{ $lang("main.close") }}</v-btn>
      <!-- <v-btn color="success" @click="apply()">{{ $lang("main.words.apply") }}</v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AmountDetailsForm",
  props: {
    formOptions: {
      type: Object,
      required: true,
    },
    amountDetails: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      form: {
        total: null,
        amount_details: []
      }
    }
  },
  beforeMount() {
    this.form = {...this.formOptions}
    this.form.amount_details = this.amountDetails;
  },
  methods: {
    close() {
      this.$emit('close');
    },
    apply() {
      this.$emit('apply');
    }
  },
  computed: {
    total() {
      if (!this.form.amount_details || !this.form.amount_details.length) return;

      let total = 0;
      this.form.amount_details.forEach(item => {
        total += parseFloat(item.amount);
      })

      return total.toFixed(2);
    },
    ...mapState({
      validation: state => state.reservations.creationWizardRequest.validation,
    }),
  },
};
</script>

<style scoped>

</style>
